import { useRef, useEffect, useCallback } from 'react';

export function useSingletonAudio(src, volume = 0.8) {
  const audioRef = useRef(null);

  useEffect(() => {
    if (!src) {
      audioRef.current = null;
      return;
    }

    if (!audioRef.current) {
      audioRef.current = new Audio(src);
    }

    audioRef.current.volume = volume;

    return () => {
      if (audioRef.current) {
        try {
          audioRef.current.pause();
        } catch {}
      }
      audioRef.current = null;
    };
  }, [src, volume]);

  const play = useCallback(() => {
    if (!src || !audioRef.current) {
      return;
    }

    try {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(() => {});
    } catch {}
  }, [src]);

  return play;
}
